/* eslint-disable no-param-reassign */

// accessing the DOM directly is not a good idea
// See also: https://medium.com/@krithika0/how-to-build-reliable-search-highlighting-for-your-product-2bf581b8289c

/**
 * Highlight text in htmlCollection
 */

const getHighlightedText = (texts: string[], innerHTML: string) => {
    const highlights: number[] = [];
    const lowercase = innerHTML.toLowerCase();
    texts.forEach((text) => {
        let startAt = 0;
        let index = lowercase.indexOf(text.toLowerCase());
        while (index !== -1) {
            if (index === -1) {
                break;
            } else {
                for (let i = startAt + index; i < startAt + index + text.length; i++) {
                    if (highlights.indexOf(i) === -1) {
                        highlights.push(i);
                    }
                }
                startAt = startAt + index + text.length;
            }
            index = lowercase.substring(startAt).indexOf(text.toLowerCase());
        }
    });

    const highlightsArray: number[][] = highlights.reduce((r, n) => {
        const lastSubArray = r[r.length - 1];

        if (!lastSubArray || lastSubArray[lastSubArray.length - 1] !== n - 1) {
            r.push([]);
        }

        r[r.length - 1].push(n);

        return r;
    }, []);
    highlightsArray.sort((a, b) => (a[0] > b[0] ? -1 : 1));
    for (const highlight of highlightsArray) {
        innerHTML = `${innerHTML.substring(0, highlight[0])}<span class='highlight'>${innerHTML.substring(
            highlight[0],
            highlight[highlight.length - 1] + 1,
        )}</span>${innerHTML.substring(highlight[highlight.length - 1] + 1)}`;
    }
    return innerHTML;
};

export const handleHighlight = (
    text: string,
    ignoreSpacings = false,
    className = "highlightText",
    doc = document,
): void => {
    if (text) {
        // highlight text
        const inputText = doc.getElementsByClassName(className);
        for (let i = 0; i < inputText.length; i++) {
            // innerText is not supported by jsdom -> use textContent!!!
            inputText[i].innerHTML = inputText[i].textContent;
            let { innerHTML } = inputText[i];
            innerHTML = innerHTML.replace("&nbsp;", " "); // remove empty space code and place an empty space

            if (ignoreSpacings) {
                innerHTML = getHighlightedText([text, ...text.trim().split(" ")], innerHTML);
            } else {
                innerHTML = getHighlightedText([text.trim()], innerHTML);
            }
            inputText[i].innerHTML = innerHTML;
        }
    } else {
        // remove highlights
        const els = doc.querySelectorAll(".highlight");
        for (let i = 0; i < els.length; i++) {
            els[i].classList.remove("highlight");
        }
    }
};

export const downloadFile = (fileBlob: Blob, fileName: string): void => {
    const href = URL.createObjectURL(fileBlob);

    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};
